var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.546 45.112"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-113.053 -327.934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.226 338.784a6.629 6.629 0 00-5.41 1.958 6.629 6.629 0 00-3.578 4.505c-.561 3.124 3.366.333 5.726-1.318.029-.023.064-.046.094-.069l.1-.067c2.312-1.712 6.207-4.546 3.068-5.009z",
    fill: "#f7d11c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.343 340.413c.418.581-.059 1.639-1.065 2.362s-2.161.839-2.579.258.059-1.639 1.065-2.363 2.161-.839 2.579-.257z",
    fill: "#f8ed42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.165 338.628c3.113 4.329 6.8 13.03-9.218 24.547-15.724 11.306-23.092 5.253-26.205.923-4.66-6.48.241-16.394 10.022-23.428s20.741-8.523 25.401-2.042z",
    fill: "#f37a20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.213 365.628a51.505 51.505 0 003.734-2.453q1.483-1.068 2.745-2.1l-2.335-3.249.948-1.147 2.49 3.463c.552-.48 1.065-.953 1.55-1.421l-2.9-4.036-8.737 7.458zM132.091 365.7c-1.406-1.473-6.8-.079-6.8-.079l3.312 3.786a12.758 12.758 0 001.742.215l-3.278-3.5 1.436-.224 3.629 3.713a17.776 17.776 0 003.182-.525z",
    fill: "#faac1a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.815,
    cy: 12.095,
    rx: 21.815,
    ry: 12.095,
    transform: "rotate(-35.719 604.935 1.27)",
    fill: "#faac1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.437 335.838a6.682 6.682 0 01.869.984c3.819 5.31-.85 15.2-10.428 22.086s-20.438 8.165-24.256 2.854a6.708 6.708 0 01-.656-1.137 7.091 7.091 0 001.148 2.6c3.9 5.424 14.991 4.118 24.773-2.916s14.55-17.132 10.65-22.555a7.071 7.071 0 00-2.1-1.916z",
    fill: "#f7d11c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.744,
    cy: 8.73,
    rx: 15.744,
    ry: 8.73,
    transform: "rotate(-35.7 606.723 -9.911)",
    fill: "#8d381e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.894,
    cy: 7.506,
    rx: 13.894,
    ry: 7.506,
    transform: "rotate(-35.719 609.13 -13.65)",
    fill: "#f7d11c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.121 343.656c2.01 2.795-.555 8.076-5.728 11.795s-11 4.47-13.005 1.676.555-8.075 5.728-11.8 10.996-4.465 13.005-1.671z",
    fill: "#faac1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.671 358.572c.307.428-.044 1.206-.784 1.738s-1.59.618-1.9.19.043-1.206.783-1.739 1.593-.617 1.901-.189zM143.291 355.262c.307.428-.044 1.206-.784 1.739s-1.59.617-1.9.189.043-1.206.783-1.739 1.593-.617 1.901-.189z",
    fill: "#f8ed42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.42 343.225a6.633 6.633 0 00-5.411 1.958 6.631 6.631 0 00-3.578 4.5c-.56 3.124 3.366.333 5.727-1.318.029-.023.064-.046.094-.069s.064-.047.1-.067c2.312-1.707 6.207-4.541 3.068-5.004z",
    fill: "#f7d11c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.537 344.854c.418.582-.059 1.639-1.065 2.363s-2.161.839-2.579.257.059-1.639 1.065-2.362 2.161-.839 2.579-.258z",
    fill: "#f8ed42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.117 342.658l3.951 1.154a.259.259 0 00.289-.106l2.253-3.444a.258.258 0 01.464.213l-1.154 3.951a.259.259 0 00.107.289l3.444 2.254a.258.258 0 01-.214.464l-3.951-1.154a.256.256 0 00-.288.107l-2.254 3.444a.258.258 0 01-.464-.214l1.154-3.951a.259.259 0 00-.107-.289l-3.444-2.253a.259.259 0 01.214-.465zM144.953 355.266l1.254 2.288a.163.163 0 00.177.082l2.553-.534a.164.164 0 01.112.3l-2.287 1.254a.162.162 0 00-.082.177l.534 2.553a.164.164 0 01-.3.113l-1.254-2.288a.162.162 0 00-.177-.082l-2.553.534a.164.164 0 01-.113-.3l2.288-1.254a.163.163 0 00.082-.177l-.534-2.553a.164.164 0 01.3-.113z",
    fill: "#fff"
  }))));
}

export default SvgIconCoin;